"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGetDisplayedItem;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.includes.js");
var _react = require("react");
function useGetDisplayedItem(ids, currentElementClass) {
  let testing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const [currentElement, setCurrentElement] = (0, _react.useState)(ids[0]);
  const headingElementsRef = (0, _react.useRef)({});
  (0, _react.useEffect)(() => {
    const triggerCallBack = () => {
      const callback = headings => {
        headingElementsRef.current = headings.reduce((map, headingElement) => {
          map[headingElement.target.id] = headingElement;
          return map;
        }, headingElementsRef.current);
        const visibleHeadings = [];
        Object.keys(headingElementsRef.current).forEach(key => {
          const headingElement = headingElementsRef.current[key];
          if (headingElement.isIntersecting) visibleHeadings.push(key);
        });
        for (let i = 0; i < ids.length; i++) {
          if (visibleHeadings.includes(ids[i])) {
            setCurrentElement(ids[i]);
            i = ids.length; // End loop to get only the first intersecting element
          }
        }
      };

      let topMargin = 0;
      if (!testing) {
        try {
          topMargin = +window.getComputedStyle(document.querySelector(".".concat(currentElementClass))).getPropertyValue('top').split('px')[0] || 0;
        } catch (error) {
          console.log(error);
        }
        const observer = new IntersectionObserver(callback, {
          rootMargin: "-".concat(topMargin + 0.01, "px 0px 0px 0px")
        });
        const headingElements = ids.reduce((prev, curr) => {
          const element = document.getElementById(curr);
          if (element) return [...prev, element];else return prev;
        }, []);
        headingElements.forEach(element => observer.observe(element));
        return () => observer.disconnect();
      }
    };
    document.addEventListener('scroll', triggerCallBack, {
      once: true
    });
  }, [...arguments]);
  return currentElement;
}